module.exports = __webpack_public_path__ + "img/step43_a_printer_basic_place_on_stand.350e5648.png";